import { Collection, Q } from '@nozbe/watermelondb';

import { DBServiceOptionsWithImages } from '../../types/dbService';
import { EventHorseModel } from '../../types/EventHorse';

/**
 * Read-only facade for event_horses.
 * Writes go through Event helpers or Horse.deleteByID cascade.
 */
class EventHorse {
    private collection: Collection<EventHorseModel>;
    private table = 'event_horses';

    constructor(options: DBServiceOptionsWithImages) {
        this.collection = options.database.collections.get(this.table);
    }

    getByID(id: string) {
        return this.collection.find(id);
    }

    async getByParam(param: string, value: any) {
        return this.collection.query(Q.where(param, value)).fetch();
    }
}

export default EventHorse;
